import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { usePqrTypeDetail } from './hook';
import { PqrTypeData } from './data';
import { PqrTypeParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    PQR_TYPE_NEW,
    PQR_TYPE,
    PQR_TYPE_EDIT,
    PQR_TYPE_DETAIL,
} from '../../../../../routes/paths';
import { PqrTypeRegisterHistory } from './registerHistory';

export const PqrTypeDetail = () => {
    const { pqrType, pqrTypeHistorical, showHistorical, setShowHistorical } =
        usePqrTypeDetail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle Tipo PQR"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={pqrType?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_TYPE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_TYPE,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_TYPE_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: PQR_TYPE_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(pqrType?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <PqrTypeParamsHistorical
                            historical={pqrTypeHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <PqrTypeData data={pqrType} />
                </LayoutModule>
            </LayoutModule>
            <PqrTypeRegisterHistory pqrType={pqrType} />
        </>
    );
};
